import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const updateExternalExamOperation = async (
  externalExamId: number,
  examName: string,
  symbol: string,
  majorSymbol: string,
  majorId: number,
  paymentServiceId: number | null,
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!examName || examName.length === 0) {
      toast.warn(`יש להזין את שם המקצוע`);
      console.warn(`External exam name must not be empty`);
      return;
    }
    if (examName.length < 1 || examName.length > 50) {
      toast.warn('על שם המקצוע להיות באורך של 1-50 תווים');
      return;
    }
    if (!symbol || symbol.length === 0) {
      toast.warn(`יש להזין את הסמל`);
      console.warn(`Symbol must not be empty`);
      return;
    }
    if (symbol.length < 1 || symbol.length > 50) {
      toast.warn('על הסמל להיות באורך של 1-50 תווים');
      return;
    }
    if (!majorSymbol || majorSymbol.length === 0) {
      toast.warn(`יש להזין את סמל המגמה`);
      console.warn(`Major symbol must not be empty`);
      return;
    }
    if (majorSymbol.length < 1 || majorSymbol.length > 50) {
      toast.warn('על סמל המגמה להיות באורך של 1-50 תווים');
      return;
    }
    if (!majorId || majorId <= 0) {
      toast.warn(`יש לבחור מגמה`);
      console.warn(`Major ID must be a positive integer`);
      return;
    }
    if (!paymentServiceId || paymentServiceId <= 0) {
      toast.warn(`יש לבחור שירות תשלום`);
      console.warn(`Payment service ID must be a positive integer`);
      return;
    }

    const existingExternalExam = globalSettingsStores.externalExams.find(
      (item) =>
        item.id !== externalExamId &&
        (item.examName === examName || item.symbol === symbol),
    );
    if (existingExternalExam) {
      toast.warn('שם מבחן חיצוני או סמל כבר קיימים במערכת');
      return;
    }

    setLoading(true);
    const res = await appApi.updateExternalExam(
      externalExamId,
      examName,
      symbol,
      majorSymbol,
      majorId,
      paymentServiceId,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      await globalSettingsStores.fetchSetting();
      toast.success(`עדכון ${examName} התבצע בהצלחה`);
      onHide();
    }
    setLoading(false);

    return;
  } catch (e) {
    toast.error('עדכון מבחן חיצוני נכשל, נסה שוב בעוד מספר רגעים...');
    console.error(
      `updateExternalExamOperation is failed with the externalExamId: ${externalExamId}, examName: ${examName}, symbol: ${symbol}, majorSymbol: ${majorSymbol}, majorId: ${majorId}, paymentServiceId: ${paymentServiceId} and the error: ${e}`,
    );
    setLoading(false);
  }
};
